import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { IconAlfaLogo } from '@alfa-bank/site-icon/alfa-logo';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { Stack, stackingOrder } from '@alfa-bank/site-stack';
import { YandexSearchBar } from '@alfa-bank/site-yandex-search/search-bar-desktop';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';

import { ApplicationsButton } from './components/applications-button';
import { MainHeaderV2 as Component } from './component-desktop';
import type { TMainHeader, IDeps } from './models/desktop';
import { BannerLink } from './components/banner-link';
import { DropDownContextProvider } from './components/drop-down/drop-down-context';
import { SegmentLink } from './components/segment-link';
import { InternetBank } from './components/internet-bank';
import { SearchIcon } from './components/search-icon';
import { SubsectionLink } from './components/subsection-link';
import { TopRow } from './components/top-row';
import styles from './styles/styles.css';

export const MainHeaderV2Desktop = createWidget<IDeps, TMainHeader>({
    ApplicationsButton,
    BannerLink,
    DataLayer,
    DropDownContextProvider,
    IconAlfaLogo,
    styles,
    SubsectionLink,
    Stack,
    stackingOrder,
    InternetBank,
    SearchIcon,
    SegmentLink,
    TopRow,
    Layout,
    YandexSearchBar,
    useNamedContainers,
})(Component);
